
<template>
    <div class="details"> 
        <div class="details_content">
            <div class="title">{{info.title}}</div>
            <!-- <video width="100%" autoplay controls="controls">
                <source :src="info.spUrl" type="video/mp4" />
            </video> -->
            <VideoPlay :src="info.spUrl" :posterSrc="info.imageInputs"></VideoPlay>
            <div class="content">
                <div class=""><span style="color:#999">视频简介：</span>{{info.shareSynopsis}}</div>
                <div><span style="color:#999">视频内容：</span><p v-html="info.content" class="info"></p></div>
            </div>
        </div>
        <v-footer></v-footer>
    </div>
</template>

<script>
import VideoPlay from '@/components/videoPlay.vue'
export default {
   components:{VideoPlay},
   data(){
    return{
        info:{}
    }
   },
   created(){
     this.info = JSON.parse(sessionStorage.getItem('videoData'))
   },
   methods:{

   }

}
</script>

<style lang="less">
.details{
    background: #F5F5F5;
    height: calc(100% -0.2rem);
    padding-bottom: 0.8rem;
    .details_content{
        // margin: 0.1rem 0.2rem;
        // margin-top: 0.3rem;
        background: #fff;
        padding: 0.1rem 0.2rem;
        padding-bottom: 0.2rem;
        font-size: 0.28rem;
        color: #000;
        .title{
            font-size: 0.28rem;
            color: #000;
            font-weight: bold;
            margin-bottom: 0.2rem;
            margin-top: 0.2rem;
            
        }
        .content{
            margin-top: 0.2rem;
            line-height: 0.45rem;
            .info{
                img{
                    max-width: 100%;
                    height: auto;
                }
            }
        }
        .tip{
            span{
                display: inline-block;
                background: #F5F5F5;
                border-radius: 0.04rem;
                color: #666666;
                font-size: 0.2rem;
                margin-right: 0.18rem;
                padding: 0.05rem 0.1rem;
                
            }
            padding: 0.2rem 0.05rem;
            border-bottom: 1px solid #EDEDED;
          }
          .info{
              margin-top: 0.26rem;
              section{
                img{
                    max-width: 100%!important;
                    height: auto!important;
                }
                p{
                    line-height: 0.5rem;
                    span{
                        line-height: 0.5rem;
                    }
                }
              }
          }
    }                                       
}
</style>


// WEBPACK FOOTER //
// src/modules/videoDetail.vue